export default "__VITE_ASSET__DOl7iluh__"